import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cap-title-functionbar',
  templateUrl: './title-functionbar.component.html',
  styleUrls: ['./title-functionbar.component.scss']
})
export class TitleFunctionbarComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
